// extracted by mini-css-extract-plugin
export default {"participantItem":"UserDisplay_participantItem__n3u-2","participantInfo":"UserDisplay_participantInfo__CX+CB","consentCheckBox":"UserDisplay_consentCheckBox__K6J9q"};